<template>
  <div
    class="map-wrapper"
    :class="{
      'map-wrapper-nosidebar': isNoSideBar
    }">
    <h3>Shelter Status</h3>
    <router-link :to="{name: 'Shelter'}">
      <b-button>
        <b-icon icon="menu"/> &nbsp; Shelter List
      </b-button>
    </router-link>
    <router-link :to="{name: 'ListShelterStatus'}">
      <b-button>
        <b-icon icon="menu"/> &nbsp; Shelter Status List
      </b-button>
    </router-link>
    <router-link :to="{name: 'Shelter:Create'}">
      <b-button>
        <b-icon icon="plus"/> &nbsp; Add Shelter
      </b-button>
    </router-link>
    <br/>
    <br/>
    <LMap
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      :fullscreenControl="true"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
      >
      <LTileLayer :url="url" :attribution="attribution" />
      <LMarker
        v-for="s in shelters"
        :key="s._id"
        :lat-lng="getLatLng(s.location)">
        <LPopup>
          <div>
            Name: {{s.name}}<br/>
            Status: {{s.status}}<br/>
            Occupancy: {{getStatus(s.code).occupancyStatus}}<br/>
            Capacity: {{getStatus(s.code).maxOccupancy}}<br/>
            Num of Refugees: {{getTotalRefugees(s.code)}}<br/>
            Address: {{s.address || '-'}}<br/>
            <router-link :to="{name: 'ShelterStatus:Create', params: {id: s.code}}">
              Report Status
            </router-link>
          </div>
        </LPopup>
      </LMarker>
    </LMap>
  </div>
</template>

<style lang="scss" scoped>
.map {
  &-wrapper {
    position: absolute;
    top: 50px;
    bottom: 20px;
    right: 0px;
    padding: 20px;
    height: 85vh;

    @media only screen and (min-width: 768px) {
      left: 300px;
    }

    &-nosidebar {
      left: 0px;
    }
  }
}
</style>

<script>
import {mapGetters, mapActions} from 'vuex'
import {latLng} from 'leaflet'
import {LMap, LTileLayer, LMarker, LPopup} from 'vue2-leaflet'

const DEFAULT_CENTER = latLng(-0.599094, 117.504444)

export default {
  name: 'ShelterStatus',
  data () {
    return {
      isNoSideBar: false,
      zoom: 5,
      center: DEFAULT_CENTER,
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      marker: DEFAULT_CENTER,
      mapOptions: {
        zoomSnap: 0.5
      },
      currentZoom: 0,
      currentCenter: 0
    }
  },
  mounted () {
    this.init()
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  computed: {
    ...mapGetters(['visibleSideBar']),
    ...mapGetters('Shelter', ['shelters']),
    ...mapGetters('ShelterStatus', {
      shelterStatuses: 'statuses'
    }),
    statusMapped () {
      return this.shelterStatuses.reduce((acc, i) => {
        return {
          ...acc,
          [i.shelterCode]: i
        }
      }, {})
    }
  },
  methods: {
    ...mapActions('Shelter', {
      fetchShelters: 'fetch'
    }),
    ...mapActions('ShelterStatus', {
      fetchStatuses: 'fetch'
    }),
    zoomUpdate(zoom) {
      this.currentZoom = zoom
    },
    centerUpdate(center) {
      this.currentCenter = center
      this.marker = center
    },
    init () {
      this.currentZoom = this.zoom
      this.currentCenter = this.center

      // fetch shelters
      this.fetchShelters()
    },
    getLatLng (str) {
      return latLng(...str.split(','))
    },
    getStatus (code) {
      return this.statusMapped[code] || {}
    },
    getTotalRefugees (code) {
      const obj = this.getStatus(code)
      return Number(obj.numOfRefugees)
        + Number(obj.numOfRefugeesVoluntary)
    }
  },
  watch: {
    visibleSideBar (v) {
      if (v) {
        this.isNoSideBar = false
        return
      }

      setTimeout(() => {
        this.isNoSideBar = true
      }, 600)
    },
    shelters () {
      // const filters = this.shelters.map(i => 'shelterCode[$in]' + i.code)
      // this.fetchStatuses(filters)
      this.fetchStatuses()
    }
  }
}
</script>
